export default __webpack_public_path__ + "static/media/poweredbyonro.d6a8a3f6.svg";